<div class="responsive-popup" [ngClass]="{large: size==='large'}">
  <div class="responsive-popup">

    <div class="black-overlay"></div>
    <div class="popup-wrapper " >
      <div class="responsive-background">
        <app-venster-background [color]="color"></app-venster-background>
      </div>

      <div class="popup-content-header" >
          <app-popup-header *ngIf="caption" color="blue" [showImage]="headerDecoration" [caption]="caption" ></app-popup-header>
      </div>

      <div class="popup-content">
        <ng-content></ng-content>

      </div>
    </div>
  </div>
</div>
